import { render, staticRenderFns } from "./ChatBusinessCardV2.vue?vue&type=template&id=36fbe3c2&scoped=true"
import script from "./ChatBusinessCardV2.vue?vue&type=script&lang=js"
export * from "./ChatBusinessCardV2.vue?vue&type=script&lang=js"
import style0 from "./ChatBusinessCardV2.vue?vue&type=style&index=0&id=36fbe3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbe3c2",
  null
  
)

export default component.exports